<div class="na-task-groups-container">
  @if (this.didNotInspect) {
    <div class="dni-section">
      <span
        ><b>{{ naDNItext }}</b></span
      >
      <mat-checkbox
        class="dni-checkbox"
        color="primary"
        [formControl]="dniControl"
        (change)="onDNIChange($event)"
      ></mat-checkbox>
    </div>
  }
  @if (this.commentTask) {
    <div class="comments-section">
      <span class="comment-label">{{ naCommentLabel }}</span>
      <textarea
        class="comment-text-area"
        [formControl]="naComment"
        (input)="addComment($event)"
      >
      </textarea>
    </div>
  }
</div>
